module.exports = __webpack_public_path__ + "media/src/images/icons/youtube_logo-134eb5922bea19ff82d117fa18a2cb04.svg";